const styles = theme => ({
  paper: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
  }),
  button: {
    margin: theme.spacing.unit,
    background: theme.palette.accent,
    '&:focus': {
      outline: 'none'
    },
    '&:hover': {
      backgroundColor: '#fd5622',
    }
  },
  Table: {
    '& a':{
      color: 'red'
    },
  },
})

export default styles



// WEBPACK FOOTER //
// ./src/components/customers/styles.js